module.exports = __webpack_public_path__ + "static/media/logo.8dda4be0.svg";